import React, { useId } from 'react';
import { Switch } from '@onward-delivery/design';

/**
 * An editable on/off setting: a toggle switch with its label (clicking the label flips it too).
 * When `disabled`, the switch is greyed out and `hint` can say why.
 * @param {{ checked: boolean, label: React.ReactNode, onChange: (next: boolean) => void,
 *   disabled?: boolean, hint?: string }} props
 */
const ToggleOption = ({ checked, label, onChange, disabled, hint }) => {
    const id = useId();
    return (
        <div className="flex min-w-0 flex-col gap-1">
            <div className="flex min-w-0 items-center gap-4">
                <Switch id={id} size="lg" checked={checked} onCheckedChange={onChange} disabled={disabled} />
                <label
                    htmlFor={id}
                    className={`min-w-0 flex-1 break-words text-base text-foreground ${
                        disabled ? 'cursor-default' : 'cursor-pointer'
                    }`}
                >
                    {label}
                </label>
            </div>
            {hint && <span className="pl-[70px] text-sm text-muted">{hint}</span>}
        </div>
    );
};

export default ToggleOption;
